<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" translate="MAINTENANCES.TITLE"> Maintenances </span>

      <div class="page-buttons">
        <button
          [disabled]="!hasOpenMaintenancePermission"
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES.ADD' | translate }}"
          (click)="openDialog()"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'MAINTENANCES.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasOpenMaintenancePermission"
          ></i>
        </button>

        <ng-container *showIfHasFeatureFlag="'weight'">
          <button
            *ngIf="hasCreateExportPermission"
            mat-stroked-button
            matTooltip="{{ 'MAINTENANCES.EXPORT_EXCEL_IMR' | translate }}"
            (click)="openExportDialogImr()"
          >
            <i class="angularjs-fuse-icon icon-export"></i>
          </button>
        </ng-container>

        <button
          *ngIf="hasCreateExportPermission"
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES.EXPORT_EXCEL' | translate }}"
          (click)="openExportDialog()"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES.CHANGE_COLUMNS' | translate }}"
          [matMenuTriggerFor]="menuColumns"
        >
          <i class="angularjs-fuse-icon icon-table-edit"></i>
        </button>

        <mat-menu #menuColumns="matMenu">
          <span *ngFor="let column of columns">
            <button
              *ngIf="column.name !== 'edit'"
              mat-menu-item
              [ngClass]="{ 'maintenances__inactive-column': !displayedColumns.includes(column.name) }"
              (click)="setColumn($event, column.name)"
            >
              {{ column.title | translate }}
            </button>
          </span>
        </mat-menu>

        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES.FILTERS.TITLE' | translate }}"
          (click)="sidenavService.open('filterMaintenances')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'MAINTENANCES.RELOAD' | translate }}"
          (click)="reloadMaintenances.next()"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>
    </div>

    <datatable-maintenances
      class="content-card datatable"
      (updatedValues)="updateTotalMaintenances($event)"
      [reload]="reloadMaintenances"
      [columns]="displayedColumns"
      [hasEditMaintenancePermission]="hasEditMaintenancePermission"
    >
    </datatable-maintenances>
  </div>
</div>

<fuse-sidebar name="filterMaintenances" key="filterMaintenances" position="right" lockedOpen="true">
  <filter-maintenances class="sidebar-filter"></filter-maintenances>
</fuse-sidebar>
